
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  FormGroup,
  Alert,
  Input,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import FileUploader from "../FileUploader";

const EditProgramForm = ({
  time,
  time1,
  time2,
  title,
  description,
  title1,
  description1,
  title2,
  description2,
  coverImage,
  setCoverImage,
  coverImage1,
  setCoverImage1,
  coverImage2,
  setCoverImage2,
  handleUpdateProgram,
  handleChange,
  handleChange1,
  handleChange2,
  mediaSelecta,
  mediaSelecta1,
  mediaSelecta2,
  mediaSelecta3,
  mediaSelecta4,
  mediaSelecta5,
  mediaSelecta6,
  mediaSelecta7,
  mediaSelecta8,
  mediaSelectb,
  mediaSelectb1,
  mediaSelectb2,
  mediaSelectb3,
  mediaSelectb4,
  mediaSelectb5,
  mediaSelectb6,
  mediaSelectb7,
  mediaSelectb8,
  mediaSelectc,
  mediaSelectc1,
  mediaSelectc2,
  mediaSelectc3,
  mediaSelectc4,
  mediaSelectc5,
  mediaSelectc6,
  mediaSelectc7,
  mediaSelectc8,
  handleMediaSelectChangeA,
  handleMediaSelectChangeA1,
  handleMediaSelectChangeA2,
  handleMediaSelectChangeA3,
  handleMediaSelectChangeA4,
  handleMediaSelectChangeA5,
  handleMediaSelectChangeA6,
  handleMediaSelectChangeA7,
  handleMediaSelectChangeA8,
  handleMediaSelectChangeB,
  handleMediaSelectChangeB1,
  handleMediaSelectChangeB2,
  handleMediaSelectChangeB3,
  handleMediaSelectChangeB4,
  handleMediaSelectChangeB5,
  handleMediaSelectChangeB6,
  handleMediaSelectChangeB7,
  handleMediaSelectChangeB8,
  handleMediaSelectChangeC,
  handleMediaSelectChangeC1,
  handleMediaSelectChangeC2,
  handleMediaSelectChangeC3,
  handleMediaSelectChangeC4,
  handleMediaSelectChangeC5,
  handleMediaSelectChangeC6,
  handleMediaSelectChangeC7,
  handleMediaSelectChangeC8,

  mediaData,
}) => {

  const mediaOptions = [
    { value: null, label: "Nothing Selected" },
    ...(mediaData || [])
  ];

  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardBody>
            <Row>
              <Col xs={12}>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h3 className="m-0">{time}</h3>
                </div>
              </Col>
            </Row>
            <AvForm className="form-horizontal" >
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <Label htmlFor="title">Title</Label>
                    <AvField
                      name="title"
                      placeholder="Enter title"
                      value={title}
                      onChange={handleChange}
                      type="text"
                      errorMessage="Title is required"
                      className="form-control"
                      validate={{ required: { value: false } }}
                      id="title"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FileUploader
                    file={coverImage}
                    setFile={setCoverImage}
                    dragText="Drop Image here"
                    heading="Select Image"
                    accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                  />
                </Col>
              </Row>

              <FormGroup>
                <Label htmlFor="description">Description</Label>
                <AvField
                  name="description"
                  placeholder="Enter description"
                  value={description}
                  onChange={handleChange}
                  type="textarea"
                  errorMessage="Description is required"
                  className="form-control"
                  validate={{ required: { value: false } }}
                  id="description"
                />
              </FormGroup>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 1</Label>
                    <Select
                      value={mediaSelecta}
                      isMulti={false}
                      onChange={handleMediaSelectChangeA}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 2</Label>
                    <Select
                      value={mediaSelecta1}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA1}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 3</Label>
                    <Select
                      value={mediaSelecta2}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA2}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 4</Label>
                    <Select
                      value={mediaSelecta3}
                      isMulti={false}
                      onChange={handleMediaSelectChangeA3}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 5</Label>
                    <Select
                      value={mediaSelecta4}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA4}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 6</Label>
                    <Select
                      value={mediaSelecta5}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA5}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 7</Label>
                    <Select
                      value={mediaSelecta6}
                      isMulti={false}
                      onChange={handleMediaSelectChangeA6}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 8</Label>
                    <Select
                      value={mediaSelecta7}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA7}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 9</Label>
                    <Select
                      value={mediaSelecta8}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeA8}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              {/*             
              <Button
                color="primary"
                className="w-100 mt-4"
                type="submit"
                // disabled={!isDataUpdated ? true : false}
              >
                {'createBtnText'}
              </Button> */}
            </AvForm>
            <br />
            {/* <Row>
              <Col>
                {alert.isAlert && (
                  <Alert color={alert.alertType} role="alert">
                    {alert.alertText}
                  </Alert>
                )}
              </Col>
            </Row> */}
          </CardBody>
          <CardBody>
            <Row>
              <Col xs={12}>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h3 className="m-0">{time1}</h3>
                </div>
              </Col>
            </Row>
            <AvForm className="form-horizontal" >
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <Label htmlFor="title">Title</Label>
                    <AvField
                      name="title"
                      placeholder="Enter title"
                      value={title1}
                      onChange={handleChange1}
                      type="text"
                      errorMessage="Title is required"
                      className="form-control"
                      validate={{ required: { value: false } }}
                      id="title"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FileUploader
                    file={coverImage1}
                    setFile={setCoverImage1}
                    dragText="Drop Image here"
                    heading="Select Image"
                    accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                  />
                </Col>
              </Row>

              <FormGroup>
                <Label htmlFor="description">Description</Label>
                <AvField
                  name="description"
                  placeholder="Enter description"
                  value={description1}
                  onChange={handleChange1}
                  type="textarea"
                  errorMessage="Description is required"
                  className="form-control"
                  validate={{ required: { value: false } }}
                  id="description"
                />
              </FormGroup>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 1</Label>
                    <Select
                      value={mediaSelectb}
                      isMulti={false}
                      onChange={handleMediaSelectChangeB}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 2</Label>
                    <Select
                      value={mediaSelectb1}
                      onChange={handleMediaSelectChangeB1}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 3</Label>
                    <Select
                      value={mediaSelectb2}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeB2}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 4</Label>
                    <Select
                      value={mediaSelectb3}
                      isMulti={false}
                      onChange={handleMediaSelectChangeB3}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 5</Label>
                    <Select
                      value={mediaSelectb4}
                      onChange={handleMediaSelectChangeB4}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 6</Label>
                    <Select
                      value={mediaSelectb5}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeB5}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 7</Label>
                    <Select
                      value={mediaSelectb6}
                      isMulti={false}
                      onChange={handleMediaSelectChangeB6}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 8</Label>
                    <Select
                      value={mediaSelectb7}
                      onChange={handleMediaSelectChangeB7}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 9</Label>
                    <Select
                      value={mediaSelectb8}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeB8}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>

            </AvForm>
            <br />

          </CardBody>
          <CardBody>
            <Row>
              <Col xs={12}>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h3 className="m-0">{time2}</h3>
                </div>
              </Col>
            </Row>
            <AvForm className="form-horizontal" >
              <Row>
                <Col>
                  <FormGroup>
                    <Label htmlFor="title">Title</Label>
                    <AvField
                      name="title"
                      placeholder="Enter title"
                      value={title2}
                      onChange={handleChange2}
                      type="text"
                      errorMessage="Title is required"
                      className="form-control"
                      validate={{ required: { value: false } }}
                      id="title"
                    />
                  </FormGroup>
                  <FileUploader
                    setFile={setCoverImage2}
                    file={coverImage2}
                    dragText="Drop Image here"
                    heading="Select Image"
                    accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                  />
                </Col>
              </Row>

              <FormGroup>
                <Label htmlFor="description">Description</Label>
                <AvField
                  name="description"
                  placeholder="Enter description"
                  value={description2}
                  onChange={handleChange2}
                  type="textarea"
                  errorMessage="Description is required"
                  className="form-control"
                  validate={{ required: { value: false } }}
                  id="description"
                />
              </FormGroup>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 1</Label>
                    <Select
                      value={mediaSelectc}
                      isMulti={false}
                      onChange={handleMediaSelectChangeC}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 2</Label>
                    <Select
                      value={mediaSelectc1}
                      onChange={handleMediaSelectChangeC1}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 3</Label>
                    <Select
                      value={mediaSelectc2}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeC2}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 4</Label>
                    <Select
                      value={mediaSelectc3}
                      isMulti={false}
                      onChange={handleMediaSelectChangeC3}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 5</Label>
                    <Select
                      value={mediaSelectc4}
                      onChange={handleMediaSelectChangeC4}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 6</Label>
                    <Select
                      value={mediaSelectc5}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeC5}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>
              <Row>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor='mediaIds'>Media 7</Label>
                    <Select
                      value={mediaSelectc6}
                      isMulti={false}
                      onChange={handleMediaSelectChangeC6}
                      options={mediaOptions}
                      classNamePrefix='selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 8</Label>
                    <Select
                      value={mediaSelectc7}
                      onChange={handleMediaSelectChangeC7}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>
                <Col ls={4}>
                  <FormGroup>
                    <Label htmlFor=''>Media 9</Label>
                    <Select
                      value={mediaSelectc8}
                      // isMulti={true}
                      onChange={handleMediaSelectChangeC8}
                      options={mediaOptions}
                      classNamePrefix='select2-selection'
                      placeholder={
                        mediaOptions && mediaOptions.length === 0
                          ? 'Loading...'
                          : 'Select Media'
                      }

                    />
                  </FormGroup>
                </Col>

              </Row>

              <Button
                color="primary"
                className="w-100 mt-4"
                type="submit"
                // disabled={!isDataUpdated ? true : false}
                onClick={handleUpdateProgram}
              >
                {'Save Changes'}
              </Button>
            </AvForm>
            <br />
            {/* <Row>
              <Col>
                {alert.isAlert && (
                  <Alert color={alert.alertType} role="alert">
                    {alert.alertText}
                  </Alert>
                )}
              </Col>
            </Row> */}

          </CardBody>
        </Card>
      </Col>
    </Row>

  );
};

export default EditProgramForm;
